<div class="container-fluid">
  <div class="container shopSection">
    <div class="row">
      <h4 class="subHeaders">
        Shop By Space
        <span class="viewAll">
          View All
        </span>
      </h4>
    </div>
    <div class="row">
      <p class="shopDescription">
        Select the type of apartment you want to light up.
      </p>
    </div>
    <div class="row ">
      <div class="d-flex justify-content-center ">
        <div class="imageContainer" *ngFor="let item of cardData">
          <div class="" style="  position: relative;">
            <img class="img-fluid imageCard" [src]="item.image" [alt]="item.title">
            <div class="imageTitle d-none d-md-block">
              {{ item.title }}
            </div>
          </div>
          <div class="p-1"></div>
          <div class="d-sm-block d-md-none" style="font-weight: 500; font-size: 16px; line-height: 120%;">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-5 d-none d-md-block"></div>

<div class="p-4  d-sm-block d-md-none"></div>
